import { useCallback, useState } from 'react';
import type { WebViewMessageEvent } from 'react-native-webview';
import { logger as LOG } from '@sweetgreen/garnish';

import { useApplePayErrorHandling } from './useApplePayErrorHandling';

LOG.enable('ApplePay');
const logger = LOG.extend('ApplePay');

export const useApplePayMessages = (props: ApplePayMessagesHandlerProps) => {
  const { onCapturePaymentMethodId } = props;
  const handleApplePayError = useApplePayErrorHandling();
  const [isApplePayEnabled, setIsApplePayEnabled] = useState(false);

  const handleApplePayMessages = useCallback(
    async (event: WebViewMessageEvent) => {
      const message = parseApplePayMessage(event);
      const { paymentMethodId, applePayEnabled, error } = message;

      logger.info(message);

      if (error) {
        handleApplePayError(error);
      }

      if (applePayEnabled) {
        setIsApplePayEnabled(true);
      }

      if (paymentMethodId) {
        await onCapturePaymentMethodId?.(paymentMethodId);
      }
    },
    [handleApplePayError, onCapturePaymentMethodId],
  );

  return { isApplePayEnabled, handleApplePayMessages };
};

const parseApplePayMessage = (event: WebViewMessageEvent) => {
  const dataString = event.nativeEvent.data ?? '{}';
  const parsedData = JSON.parse(dataString) as HostedFieldsPayload;

  return parsedData;
};

// ─── Types ─────────────────────────────────────────────────────────────────────

type ApplePayMessagesHandlerProps = Readonly<{
  onCapturePaymentMethodId?: (paymentMethodId: string) => Promise<void>;
}>;

type HostedFieldsPayload = Readonly<{
  log?: string;
  paymentMethodId?: string;
  applePayEnabled?: boolean;
  error?: { message?: string };
}>;
